import styled from 'styled-components';
import colors from 'constants/colors';

export const Head = styled.div`
  position: relative;
  font-size: 22px;
  font-weight: 600;
  color: ${colors.green};
  margin-bottom: 16px;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  
  .inputRow {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    column-gap: 16px;
    margin: 8px 0 24px 0;
  }
`;

export const Footer = styled.div`
  font-weight: 300;
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
  padding-top: 24px;
`;
